/*
 * @Description: 
 * @Author: luocheng
 * @Date: 2021-12-13 11:43:40
 * @LastEditors: luocheng
 * @LastEditTime: 2022-05-17 15:09:27
 */
import { axios } from '../http/request';
//表单渲染器
export const formRequest = (method,url,data = {}) => {
	// console.log(url, 'formRequest-url')
	if(method === 'get' || method === 'GET'){
		return axios.request({
			url,
			method: method,
			params: data
		})
	} else {
		return axios.request({
			url,
			method: method,
			data: data
		})
	}
};